import * as React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import { store } from "./app/store";

import App from "./App";

import "./styles/common.css";
// import "./styles/layout.css";
import "./styles/inbox.css";
import "./styles/style.css";
import "./styles/button.css";
import "./styles/custom.css";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root"),
);
